import ArticleCard from "@/components/feature/ArticleCard";
import SectionHeading from "@/components/base/SectionHeading";
import { articles } from "@/mocks/articles";

export default function LatestSection() {
  const list = articles.slice(0, 6);

  return (
    <section className="mx-auto max-w-editorial px-4 py-14 md:px-6 md:py-20">
      <SectionHeading
        eyebrow="最新复盘"
        title="刚刚整理完的新鲜内容"
        desc="每篇都标注了信息来源方向与关键节点，方便你快速判断是否值得细读。"
        action={{ label: "全部深度复盘", href: "/insights" }}
      />
      <div className="mt-9 grid grid-cols-1 gap-x-10 md:grid-cols-2">
        {list.map((item) => (
          <ArticleCard key={item.slug} article={item} variant="horizontal" />
        ))}
      </div>
    </section>
  );
}